import React, { ReactNode } from "react"

import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"

import { ContentOverlayView } from "./ContentOverlayView"

export interface ContentOverlayPayload {
  headline: string
  children: ReactNode
}

export interface ContentOverlayProps {
  payload: ContentOverlayPayload
}

export const ContentOverlay = React.memo(({ payload }: ContentOverlayProps) => {
  const { closeOverlay } = useCurrentOverlay()
  return (
    <ContentOverlayView headline={payload.headline} onClose={closeOverlay}>
      {payload.children}
    </ContentOverlayView>
  )
})

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    CONTENT_OVERLAY: ContentOverlayPayload
  }
}
